import { call, put, takeEvery, select, all, fork } from "redux-saga/effects";
import { BULK_UPLOAD_START, BULK_SUMMARY_GET, BULK_TASKS_LIST_GET } from "./actionTypes";
import {
  bulkUploadSuccess,
  bulkUploadFail,
  bulkSummarySuccess,
  bulkSummaryFail,
  bulkTasksListSuccess,
  bulkTasksListFail,
  bulkTaskStatusUpdate,
} from "./actions";
import { postBulkScheduleUpload, getBulkScheduleSummary } from "../../helpers/api_rombo_helper";
import { createSelector } from "reselect";

const selectToken = createSelector(
  (state) => state.Login,
  (login) => login.token
);

function* uploadBulkSchedule({ payload: { formData, params } }) {
  try {
    const token = yield select(selectToken);
    const response = yield call(postBulkScheduleUpload, token, formData, params);

    yield put(bulkUploadSuccess(response));

    if (response?.status === "success") {
      yield put(bulkSummarySuccess(response));
      yield put(bulkTaskStatusUpdate("confirmed", []));
    }
  } catch (error) {
    yield put(
      bulkUploadFail(
        error?.response?.data ?? error ?? { message: "Upload failed" }
      )
    );
  }
}

function* fetchBulkSummary({ payload: { taskId, format } }) {
  try {
    const token = yield select(selectToken);
    const response = yield call(getBulkScheduleSummary, token, taskId, format);

    yield put(bulkSummarySuccess(response));

    if (response?.status === "success") {
      yield put(bulkTaskStatusUpdate("confirmed", []));
    } else if (response?.status === "error") {
      yield put(bulkTaskStatusUpdate("error", response.errors ?? []));
    }
  } catch (error) {
    yield put(
      bulkSummaryFail(
        error?.response?.data ?? error ?? { message: "Summary fetch failed" }
      )
    );
  }
}

function* watchBulkUpload() {
  yield takeEvery(BULK_UPLOAD_START, uploadBulkSchedule);
}

function* watchBulkSummary() {
  yield takeEvery(BULK_SUMMARY_GET, fetchBulkSummary);
}

function* bulkScheduleSaga() {
  yield all([fork(watchBulkUpload), fork(watchBulkSummary)]);
}

export default bulkScheduleSaga;
